import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import api from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { getWorkers } from "../../State/Worker/Action";
import { getFilteredSalaries } from "../../State/Salary/Action";
import AppPagination from "../Tools/AppPagination";

const SalaryList = () => {
  const [workerList, setWorkerList] = useState([]);
  const [workerId, setWorkerId] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [salaries, setSalaries] = useState([]);
  const [totalSalary, setTotalSalary] = useState(0);
  const [partnerName, setPartnerName] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const { worker } = useSelector((store) => store);
  const { salary } = useSelector((store) => store);
  const dispatch = useDispatch();

  // Fetch list of workers (you can filter based on role = WORKER from backend)
  useEffect(() => {
    dispatch(getWorkers());
  }, []);

  const handleFilter = () => {
    if (!year || !month) return;

    const params = new URLSearchParams({
      partnerId: workerId || "", // Pass empty string if undefined
      year: year.toString(),
      month: month.toString(),
      page: page.toString(),
    });

    const queryString = params.toString(); // e.g., "partnerId=abc&year=2025&month=6&page=0"

    dispatch(getFilteredSalaries(queryString));
  };

  useEffect(() => {
    handleFilter();
  }, [workerId, year, month, page]);

  useEffect(() => {
    setSalaries(salary.salaryList?.salaries);
    setTotalSalary(salary.salaryList?.salary || 0);
    setPartnerName(salary.salaryList?.partner || "");
    setTotalPages(salary.salaryList?.totalPages || 0);
  }, [salary.salaryList]);

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>
        Salary List
      </Typography>

      <Box display="flex" gap={2} mb={3}>
        <FormControl fullWidth>
          <InputLabel>Partner</InputLabel>
          <Select
            value={workerId}
            onChange={(e) => setWorkerId(e.target.value)}
            label="Worker"
          >
            {worker?.workers.map((worker) => (
              <MenuItem key={worker.id} value={worker.id}>
                {worker.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Year</InputLabel>
          <Select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            label="Year"
          >
            {[...Array(5)].map((_, i) => {
              const y = new Date().getFullYear() - i;
              return (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Month</InputLabel>
          <Select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            label="Month"
          >
            {[...Array(12)].map((_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button variant="contained" onClick={handleFilter}>
          Filter
        </Button>
      </Box>

      {salaries?.length > 0 && (
        <>
          <Typography variant="subtitle1">Partner: {partnerName}</Typography>
          <Typography variant="subtitle1">
            Total Salary: ₹{totalSalary.toFixed(2)}
          </Typography>

          <Paper sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Worker</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Payment Date</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Reference No</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {salaries.map((salary, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{salary.worker}</TableCell>
                    <TableCell>₹{salary.amount}</TableCell>
                    <TableCell>
                      {new Date(salary.paymentDate).toLocaleString()}
                    </TableCell>
                    <TableCell>{salary.paymentMethod}</TableCell>
                    <TableCell>{salary.type}</TableCell>
                    <TableCell>{salary.description}</TableCell>
                    <TableCell>{salary.referenceNo}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>

          <AppPagination setPage={setPage} totalPages={totalPages} />
        </>
      )}
    </Box>
  );
};

export default SalaryList;
